const works = [
  {
    id: 12,
    title: 'Azure Application Gateway with PostgreSQL Flexible Server',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project06.png',
    desc: 'This project deploys a private three-tier-style Azure architecture with an Application Gateway, a Linux Virtual Machine Scale Set (VMSS), and Azure Database for PostgreSQL Flexible Server.',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/05-Project06-ApplicationGateway-PostgreSQL/README.md',
  },
  {
    id: 11,
    title: 'Azure Application Gateway with TLS, Key Vault, and Error Pages',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project05.png',
    desc: 'This project deploys an Azure Application Gateway that redirects HTTP traffic to HTTPS, terminates TLS with a certificate stored in Azure Key Vault, and forwards requests to a two-instance Linux Virtual Machine Scale Set (VMSS).',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/04-Project05-ApplicationGateway-SSL/README.md',
  },
  {
    id: 10,
    title: 'Azure Application Gateway with Host-Based Routing',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project04.png',
    desc: 'This project deploys an Azure Application Gateway that routes HTTP requests to two independent Linux Virtual Machine Scale Sets (VMSS) by hostname. Terraform provision the networking, gateway, backend VMSS instances, public DNS records, NAT Gateway, and a dedicated management host.',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/03-Project04-ApplicationGateway/README.md',
  },
  {
    id: 9,
    title: 'Azure Traffic Manager with Multi-Region Load Balancing',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project03.png',
    desc: 'This project demonstrates how to set up Azure Traffic Manager for global traffic distribution across multiple geographic regions in Microsoft Azure. This project uses Terraform and bash scripts to automate the deployment and configuration process.',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/02-Project03-TrafficManager/README.md',
  },
  {
    id: 8,
    title: 'Multi-Tier VMSS Architecture with Dual Load Balancers',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project02.png',
    desc: 'This project implements a production-ready, multi-tier web application architecture in Microsoft Azure featuring two Virtual Machine Scale Sets (VMSS) with independent load balancers, cloud-native storage integration, and hybrid DNS configuration spanning Azure and AWS.',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/01-Project02-WebVMSS/README.md',
  },
  {
    id: 7,
    title: 'Linux Virtual Machine and Load Balancer',
    category: 'Azure Solutions',
    img: './img/works/solutions/azure-architecture-solutions-Project01.png',
    desc: 'This project demonstrates how to set up a Linux Virtual Machine (VM) in Microsoft Azure, with a load balancer to distribute incoming traffic across multiple instances for high availability and reliability using Terraform and bash scripts to automate the deployment and configuration process.',
    githubLik:
      'https://github.com/Richardbmk/azure-architecture-solutions/blob/main/00-Project01-LinuxVM/README.md',
  },
  {
    id: 6,
    title: 'DevOps Mini Project with AI/ML Features',
    category: 'DevOps & SRE',
    img: './img/works/devops/SRE-TASK-Page-1.drawio.png',
    desc: 'This is a DevOps project that deploys a simple Python web service application with FastAPI (REST API) connected to a PostgreSQL database. The solution combines Infrastructure as Code (Terraform), configuration management (Ansible), containerization (Docker), and cloud deployment (AWS) to create a robust, scalable production environment for the FastAPI application with PostgreSQL database.',
    githubLik: 'https://github.com/Richardbmk/ai-mini-project',
  },
  {
    id: 5,
    title: 'SRE - NGINX Reverse Proxy with SSL',
    category: 'DevOps & SRE',
    img: './img/works/devops/SRE-TASK-Page-1.drawio.png',
    desc: 'The present project provides an automated solution for deploying a simple web application with Nginx as a reverse proxy and SSL certificates from Lets Encrypt. The infrastructure solution is provided on AWS using Terraform, and the application components are containerized using Docker and Docker Compose.',
    githubLik: 'https://github.com/Richardbmk/sre-nginx-ssl-certs',
  },
  {
    id: 4,
    title: 'Comfy Sloth - Frontend App',
    category: 'Frontend',
    video: 'wcJH2HTzKBA',
    img: './img/works/frontend/ezgif-4-c681ecd364.gif',
    desc: 'E-commerce application built using ReactJS and AWS. It provides secure user authentication (Auth0), product viewing, and secure payments through Stripe. It uses AWS services such as Lambda and S3 for serverless backend architecture, and a CI/CD pipeline for seamless deployments',
    githubLik: 'https://github.com/Richardbmk/comfysloth',
    liveDemo: 'https://d1zhh0zrxyj2ke.cloudfront.net/',
  },
  {
    id: 3,
    title: 'AWS EKS Architecture Architectures',
    category: 'AWS Solutions',
    video: 'wqULqmldwNg',
    img: './img/works/solutions/aws-eks-solutions/EKS Architecture 03.jpg',
    desc: 'I have designed multiple AWS architecture diagrams that showcase different solutions using Amazon EKS. These diagrams demonstrate how different AWS services can be leveraged to build a scalable, highly available, and secure Kubernetes infrastructure.',
    githubLik:
      'https://github.com/Richardbmk/aws-architecture-solutions/tree/master/aws-eks-Solutions',
    liveDemo: false,
  },
  {
    id: 2,
    title: 'AWS 3 Tier Architecture',
    category: 'AWS Solutions',
    video: 'CUOrxSUSW5s',
    img: './img/works/solutions/aws-3-tier-solutions/aws-vpc-ec2-alb-rds.jpg',
    desc: 'I designed an AWS architecture for a three-tier application, utilizing EC2, RDS, VPC, ALB, CLB, NLB, ASG, Route53, ACM, CW, SNS, CodePipeline and more.',
    githubLik:
      'https://github.com/Richardbmk/aws-architecture-solutions/tree/master/aws-3-tier-Solutions',
    liveDemo: false,
  },
  {
    id: 1,
    title: 'AWS ECS Fargate Architecture Solutions',
    category: 'AWS Solutions',
    video: 'gKa2F4zyrzg',
    img: './img/works/solutions/ecs-fargate-solutions/microservice-ecs01.jpg',
    desc: 'I designed and implemented an AWS architecture for a microservice application using ECR, App Mesh, ALB, CodePipeline, CodeBuild, CodeCommit, and CloudMap.',
    githubLik:
      'https://github.com/Richardbmk/aws-architecture-solutions/tree/master/aws-fargate-ecs-Solutions',
    liveDemo: false,
  },
]

export default works
